import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"training-card",style:({ width: _vm.width })},[_c(VCard,{attrs:{"href":_vm.href !== '' ? _vm.href : '#',"height":"60%","target":_vm.externalLink ? '_blank' : '_self'},on:{"click":function($event){return _vm.$emit('click')}}},[_c(VImg,{attrs:{"src":_vm.thumbnailUrl,"height":"100%"}},[_c(VIcon,{attrs:{"large":""}},[_vm._v("play")])],1)],1),_c('p',{staticClass:"text-body-1 text-sm-body-2 mt-2",domProps:{"innerHTML":_vm._s(_vm.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }